/**
 * Endpoints — panneau d'activité commerciale (admin), 3 onglets (Équipe,
 * Commercial, Journée).
 * Miroir front du contrat serveur : `server/routes/activity.routes.js`
 * (`/api/admin/activity`, §6.2 de docs/activity-panel-spec.md) et
 * `server/routes/activity-track.routes.js` (`/api/activity/track`, §6.3).
 *
 * Convention du projet : chaque fonction paramétrée reçoit un OBJET de
 * paramètres (jamais une chaîne déjà sérialisée), sérialisé ici en query
 * string. Les filtres à valeurs multiples (`userIds`, `categories`,
 * `eventKeys`) sont envoyés en CSV — format attendu par
 * `server/controllers/activity.controller.js`
 * (`parseIntListParam`/`parseStringListParam`).
 */

/** Sérialise un objet de params en query string, en ignorant les valeurs vides/absentes. Les tableaux sont joints en CSV. */
function buildQuery(params) {
  if (!params) return ''
  const sp = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    if (Array.isArray(value)) {
      if (value.length === 0) return
      sp.append(key, value.join(','))
      return
    }
    sp.append(key, value)
  })
  const qs = sp.toString()
  return qs ? `?${qs}` : ''
}

export const activityEndpoints = {
  // ── Onglet Équipe (§7.4) ──────────────────────────────────────────────
  // params : { period, date, from, to, includeAdmins }
  summary: (params) => `/api/admin/activity/summary${buildQuery(params)}`,

  // ── Onglet Commercial (§7.5) ──────────────────────────────────────────
  // params : { period, date, from, to }
  userDetail: (userId, params) => `/api/admin/activity/user/${userId}${buildQuery(params)}`,

  // ── Onglet Journée ──────────────────────────────────────────────────────
  // params : { from, to, includeAdmins }
  day: (params) => `/api/admin/activity/day${buildQuery(params)}`,

  // ── Réglages (D15 poids du score) ──────────────────────────────────────
  settings: () => '/api/admin/activity/settings',
  // body PUT : { scoreConfig: { effort, result } }
  updateSettings: () => '/api/admin/activity/settings',

  // ── Cibles par commercial (D16) ────────────────────────────────────────
  // params : { userId } (omis = toutes les cibles)
  targets: (params) => `/api/admin/activity/targets${buildQuery(params)}`,
  // body PUT : { userId, metricKey, targetValue } (targetValue: null = reset)
  updateTargets: () => '/api/admin/activity/targets',

  // ── Ingestion du tracking front (D7) ────────────────────────────────────
  // Hors `/api/admin` : tout utilisateur BO connecté (monté séparément côté
  // serveur, `requireAuth` seul). body POST : { sessionKey, events: [...] }
  track: () => '/api/activity/track',
}
